import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getCookie } from '@sifrovacihra/shared-ui'
import { AUTH_COOKIE } from '../utils'
import { IAppState, TInfoMessage } from '../types'

const appSlice = createSlice({
    name: 'app',
    initialState: {
        token: getCookie(AUTH_COOKIE),
    } as IAppState,
    reducers: {
        setAppMenuAction: (state, action: PayloadAction<boolean | undefined>) => {
            state.menu = action.payload
        },
        setInfoMessageAction: (state, action: PayloadAction<TInfoMessage | undefined>) => {
            state.message = action.payload
        },
        setTokenAction: (state, action: PayloadAction<string | undefined>) => {
            state.token = action.payload
        },
    },
})

export const { setAppMenuAction, setInfoMessageAction, setTokenAction } = appSlice.actions
export default appSlice.reducer
